import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export default React.memo(function Icon(props) {
    const I = props.icon;
    return _jsx(I, { className: props.className, onClick: props.onClick || (() => { }) });
});
